import { useQuery } from '@tanstack/react-query';
import { ordersClient } from '@/lib/orders-client';

interface UsePendingOrdersCountOptions {
    enabled: boolean;
    interval?: number;
}

export function usePendingOrdersCount({ enabled, interval = 30000 }: UsePendingOrdersCountOptions) {
    // localStorage + time window are read per fetch (not in the key) so the
    // badge follows the selected location without restarting the query.
    const { data } = useQuery({
        queryKey: ['pending-orders-count'],
        queryFn: async () => {
            const locationId = localStorage.getItem('orders:selectedLocationId') || undefined;
            const now = new Date();
            const from = new Date(now.getTime() - 12 * 60 * 60 * 1000);
            const response = await ordersClient.getToday({
                locationId,
                from: from.toISOString(),
                to: now.toISOString(),
            });
            // pos_push_failed counts too: a paid order that never reached the POS needs the
            // operator's attention even more urgently than a pending one.
            return response.data.filter(
                (order) => order.status === 'pending' || order.status === 'pos_push_failed',
            ).length;
        },
        enabled,
        refetchInterval: interval,
    });

    return { pendingCount: data ?? 0 };
}
